import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiFetch } from '@/utils/apiWrapper';

interface Attachment {
  _id: string;
  name: string;
  url: string;
}

export const mediaApiSlice = createApi({
  reducerPath: 'mediaApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['MediaApi'],
  endpoints: (builder) => ({
    fetchAttachments: builder.query<Attachment[], { companyId: string }>({
      async queryFn(config) {
        const response = await apiFetch(
          `${import.meta.env.VITE_URL_HUB_API}attachments?companyId=${config.companyId}`,
        );
        return { data: await response?.json() };
      },
    }),
  }),
});

export const { useFetchAttachmentsQuery } = mediaApiSlice;
